import type { Option } from '@atlassian/jira-issue-field-select-base/src/common/types.tsx';
import type {
	IssueLinkType,
	IssueLinkTypeServer,
	IssueLink,
	IssueLinkServerRequest,
} from '../../common/types.tsx';

export const mapDataToOption = (linkType: IssueLinkTypeServer): IssueLinkType => ({
	id: linkType.linkTypeId,
	label: linkType.relationName,
	value: linkType.relationName,
	name: linkType.linkTypeName,
	direction: linkType.direction,
});

export const mapDataToOptions = (linkTypes: IssueLinkTypeServer[]): IssueLinkType[] =>
	linkTypes.map(mapDataToOption);

export const mapOptionsToData = (option: IssueLink): IssueLinkServerRequest[] | undefined => {
	// handling the case where default value may get set in the process of setting the default value of link type dropdown but the user never selects any issues
	if (option.issues.length === 0) {
		return undefined;
	}
	const direction: string =
		option.linkType.direction === 'INWARD' ? 'inwardIssues' : 'outwardIssues';
	return [
		{
			add: {
				values: [
					{
						type: {
							id: option.linkType.id,
						},
						[direction]: option.issues.map((issue: Option) => ({
							key: issue.value,
						})),
					},
				],
			},
		},
	];
};
